import clx from 'classnames';
import type React from 'react';
import styled from 'styled-components';
import { hasRichTextAdvanced } from '../../../../../../../inputs/rich-text-advanced/hasRichTextAdvanced.ts';
import { type IAdvancedRichText } from '../../../../../../../inputs/rich-text-advanced/IAdvancedRichText.ts';
import { OptionsGroupDivider } from './OptionsGroupDivider.tsx';
import { OptionsGroupRichTextAdvancedDividerLabelRender } from './OptionsGroupRichTextAdvancedDividerLabelRender.tsx';
import { OptionsGroupRichTextAdvancedDividerTextRender } from './OptionsGroupRichTextAdvancedDividerTextRender.tsx';
import { OptionsWrapper } from './OptionsWrapper.tsx';

export const OptionsGroupWrapper = styled.div`
  width: 100%;
  min-height: 40px;
  padding-bottom: 8px;
  .ant-checkbox-group,
  .ant-radio-group {
    min-height: 40px;
  }
  &.put-top-space {
    /* padding-top: 12px; */
  }
`;

function putTopSpace(props: OptionsGroupProps) {
  if (props.widgetHideLabel || !props.label) return false;
  return true;
}

export interface OptionsGroupProps {
  children?: React.ReactNode;
  label?: IAdvancedRichText;
  vertical?: boolean;

  labelLikeText?: boolean;
  widgetHideLabel?: boolean;
}

/**
 * Wrapper per gli stili grafici di configurazione delle opzioni.
 */
export function OptionsGroup(props: OptionsGroupProps) {
  const { label, children, vertical, labelLikeText } = props;

  return (
    <OptionsGroupWrapper
      className={clx({ 'put-top-space': putTopSpace(props) })}
    >
      {hasRichTextAdvanced(label) && (
        <OptionsGroupDivider>
          {labelLikeText ? (
            <OptionsGroupRichTextAdvancedDividerTextRender text={label} />
          ) : (
            <OptionsGroupRichTextAdvancedDividerLabelRender text={label} />
          )}
        </OptionsGroupDivider>
      )}
      <OptionsWrapper
        className={clx({
          vertical,
        })}
      >
        {children}
      </OptionsWrapper>
    </OptionsGroupWrapper>
  );
}
